module.exports = __webpack_public_path__ + "img/dbg_logo241113_bb.05aa8213.svg";